import { useState, useEffect } from 'react'
import { TicketService } from 'utility'

export const GetSponserRoleList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const fetchData = async () => {
        try {
            setLoading(true)
            const result = await TicketService.getProviderRole()
            if (Object.keys(result?.Result).length) {
                setData(
                    Object.keys(result?.Result).map(ele => ({
                        label: result.Result[ele],
                        value: ele,
                    })),
                )
            }
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const refetch = () => {
        fetchData()
    }

    return {
        data,
        error,
        loading,
        refetch,
    }
}
